// import { Toast, Tooltip } from './_bootstrap';
import * as bootstrap from './_bootstrap';

// make bootstrap globally available
global.bootstrap = bootstrap;

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new bootstrap.Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new bootstrap.Toast(toastElement));

  var collapsible_add_parent_class = function() {
    once('acc-show', '.collapse').forEach((elem) => {
      elem.addEventListener('show.bs.collapse', () => {
        elem.parentNode.classList.add('active-acc');
      });
      elem.addEventListener('hide.bs.collapse', () => {
        elem.parentNode.classList.remove('active-acc');
      });
    });
    /*
    once('acc-hidden', '.collapse').forEach((elem) => {
      elem.addEventListener('hide.bs.collapse', () => {
        elem.parentNode.classList.remove('active-acc');
    })});
    */
  }

  /* we use mmenu, so we get along with CSS
  var hamburger_toggle = function() {
    once('hamburger-toggle', '.hamburger-toggle').forEach((elem) => {
      elem.addEventListener('click', () => {
        elem.children[0].classList.toggle('active');
    })});
  }
  */

  /**
   *
   *  see _layoout.scss for the sass code and further information
   *
   */
  var full_width_container = function() {
    var on_window_resize = function() {
      var body = document.querySelector('body');

      if (window.innerWidth > body.clientWidth + 5) {
          body.classList.add('has-scrollbar');
          body.setAttribute('style', '--scrollbar-width: ' + (window.innerWidth - body.clientWidth) + 'px');
      } else {
          body.classList.remove('has-scrollbar');
      }
    }

    window.addEventListener('resize', on_window_resize);
    on_window_resize();
  }

  // FIXME: josh seems to be broken
  // use bootstrap stuff instead!
  var josh = undefined;
  var initJosh = function() {
    try {
      josh = new Josh();
    } catch(e) {
      console.log(e);
    }
  }


  /*
   *
   *  Animations ...
   *
   */

  // little helper
  var removeClassesByPrefix = function(el, prefix) {
    for (let i = el.classList.length - 1; i >= 0; i--) {
      const className = el.classList[i];
      if (className.startsWith(prefix)) {
          el.classList.remove(className);
      }
    }
  }

  var animateCSS = function(element, animation, inout = '', prefix = 'animate__', cbend = false) {
    const animationName = `${prefix}${animation}`;
    const node = document.querySelector(element);

    if (!node) return;

    node.classList.add(`${prefix}animated`, animationName);

    node.addEventListener('animationstart', (event) => {
      event.stopPropagation();
      if (inout == 'in') {
        node.classList.remove('invisible');
        node.classList.add('visible');
      }
    }, {once: true});

    node.addEventListener('animationend', (event) => {
      event.stopPropagation();
      if (inout == 'out') {
        node.classList.remove('visible');
        node.classList.add('invisible');
      }
      removeClassesByPrefix(node, prefix);
      if (cbend && typeof cbend === 'function') cbend();
    }, {once: true});
  }

  var animateRCSymbol = function() {
    window.addEventListener('load', function() {
      window.setTimeout(function() {
        animateCSS('#rocketchat-iframe', 'fadeInRight', 'in', 'animate__', function() {
          animateCSS('#rocketchat-iframe', 'bounce');
        });
      }, 5000);

    });
  }

  var loadRocketChat = function(w, d, s, u) {
    w.RocketChat = function(c) { w.RocketChat._.push(c) };
    w.RocketChat._ = [];
    w.RocketChat.url = u;
    var h = d.getElementsByTagName(s)[0],
        j = d.createElement(s);
    j.async = true;
    j.src = u + '/rocketchat-livechat.min.js';
    h.parentNode.insertBefore(j, h);
  }


  /*
   *  call one-time functions
   */
  loadRocketChat(window, document, 'script', 'https://chat01.hannover-bielefeld.de/livechat');
  animateRCSymbol();
  full_width_container();
  initJosh();


  Drupal.behaviors.bahn_radix5 = {
    attach: function (context) {
      // add_smooth_scrolling();
      // dropDownOnHover();
      collapsible_add_parent_class();
      // hamburger_toggle();
      // accordion_scroll_active_top();
      // add_table_row_links('tr.row-clickable', 'a');
    }
  };

})();
